import getParameterNamesInSQLQueries from 'insights/parameters/data/getParameterNamesInSQLQueries';
import {RESTWarehouseParameter} from 'insights/parameters/RESTParameterTypes';

import {AnalyticsParameterConfigGraphQL as ParameterConfig} from '../../../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';

export default function getQueryParameterConfigs(
  sqlQuery: string,
  dashboardParameterConfigs: Array<ParameterConfig>
): Array<ParameterConfig> {
  const configsNamesInQuery = getParameterNamesInSQLQueries([sqlQuery]);
  return dashboardParameterConfigs.filter((config) => configsNamesInQuery.includes(config.systemName));
}

export function restGetQueryParameterConfigs<TRESTParameter extends RESTWarehouseParameter>(
  sqlQuery: string,
  dashboardParameters: Array<TRESTParameter>
): Array<TRESTParameter> {
  const configsNamesInQuery = getParameterNamesInSQLQueries([sqlQuery]);
  return dashboardParameters.filter((parameter) => configsNamesInQuery.includes(parameter.config.systemName));
}
